const imgOrigin = window.location.origin;
const imgPadding = 30;
/**
 * 
 * @param {String} type - 返回类型 base64/file/blob/buffer
 */
function catchScreen(type = "buffer") {
    return new Promise(async (resolve) => {
        let svg = await buildSvg();
        let canvas = await getScreenCanvas(svg);
        let png;
        if(type === "base64"){
            png = canvas.toDataURL("image/png");
            resolve(png);
        } else {
            canvas.toBlob(blob => {
                if(type === "blob"){
                    resolve(blob);
                } else {
                    if(type === "file"){
                        png = new File(blob, "screenshot.png");
                        resolve(png);
                    } else if(type === "buffer"){
                        let reader = new FileReader();
                        reader.onload = () => {
                            resolve(reader.result);
                        }
                        reader.readAsArrayBuffer(blob);
                    }
                }
            });
        }
    });
}

async function buildSvg(){
    let cssStyle = getStyleSheets();
    let div = document.createElement("div");
    let svg = document.querySelector("#blockly-container .injectionDiv .blocklySvg");
    let blockCanvas = document.querySelector("#blockly-container .injectionDiv .blocklySvg .blocklyBlockCanvas");
    let bBox = blockCanvas.getBBox();
    let { width, height, x, y } = bBox;
    let imgScale = getScale(width, height);
    svg = svg.cloneNode(true);
    svg.style.backgroundColor = "rgba(0,0,0,0)";
    let defs = svg.querySelector("defs");
    let workSpace = svg.querySelector(".blocklyWorkspace");
    let selectedBlocks = workSpace.querySelectorAll(".blocklySelected");
    selectedBlocks.forEach(block => {
        block.classList.remove("blocklySelected");
    });
    blockCanvas = blockCanvas.cloneNode(true);
    blockCanvas.setAttribute("transform", "translate(0,0) scale(" + imgScale + ")")
    const imgWidth = Math.ceil(width * imgScale + imgPadding * 2);
    const imgHeight = Math.ceil(height * imgScale + imgPadding * 2);
    Array.from(blockCanvas.children).forEach(child => {
        let translate = child.getAttribute("transform");
        let reg = /translate\(([\-\.0-9]+)\,([\-\.0-9]+)\)/;
        let matches = translate.match(reg);
        let tX = Number(matches[1]);
        let tY = Number(matches[2]);
        let nTX = tX - x + imgPadding;
        let nTY = tY - y + imgPadding;
        child.setAttribute("transform", `translate(${nTX},${nTY})`)
    })
    svg.setAttribute("width", imgWidth);
    svg.setAttribute("height", imgHeight);
    svg.setAttribute("viewBox", "0 0 " + imgWidth + " " + imgHeight);

    defs.appendChild(cssStyle);
    workSpace.innerHTML = "";
    let images = blockCanvas.querySelectorAll("image");
    await loadAllImages(images);
    blockCanvas.innerHTML = blockCanvas.innerHTML.replace(/\&nbsp\;/gi, " ");
    workSpace.appendChild(blockCanvas);
    div.appendChild(svg);
    let text = div.innerHTML;
    text = text.replace(/\n/gi, "");
    div = svg = null;
    text = 'data:image/svg+xml;base64,' + window.btoa(window.unescape(window.encodeURIComponent(text)));
    return text;
}

function getScreenCanvas(base64){
    return new Promise((resolve) => {
        let img = document.createElement("img");
        img.onload = () => {
            let cv = document.createElement("canvas");
            cv.width = img.naturalWidth;
            cv.height = img.naturalHeight;
            let ct = cv.getContext("2d");
            ct.drawImage(img, 0, 0);
            resolve(cv);
        }
        img.src = base64;
    })
    
}

function getStyleSheets(){
    let styleContext = "";
    let style1 = document.querySelector("#blockly-css-style").cloneNode(true);
    let style2 = document.querySelector("#nuwa-blockly-custom-style").cloneNode(true);
    if(style1){
        styleContext += style1.textContent;
    }
    if(style2){
        styleContext += style2.textContent;
    }
    let newStyle = document.createElement("style");
    newStyle.type = "text/css";
    newStyle.rel = "stylesheet";
    newStyle.textContent = styleContext;
    return newStyle;
}

function loadAllImages(images){
    let allPromise = [];
    images.forEach(img => {
        let href = img.getAttribute("xlink:href");
        if (!/^(https*|data\:image)/.test(href)) {
            href = `${imgOrigin}${href}`;
            img.setAttribute("xlink:href", href);
        }
        if(!/^data\:image/.test(href)){
            allPromise.push(new Promise((resolve) => {
                loadImg(href).then(res => {
                    img.setAttribute("xlink:href", res);
                    resolve();
                }).catch(() => {
                    img.parentNode.removeChild(img);
                    resolve();
                })
            }))
        }
    });
    return new Promise((resolve) => {
        Promise.all(allPromise).then(() => {
            resolve();
        }).catch(() => {
            resolve();
        });
    });
}

function loadImg(url){
    let mimeType = {
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif'
    };
    let format = url.split("?")[0];
    format = format.split(".").pop();
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                if(xhr.status === 200){
                    let blob = xhr.response;
                    let type = xhr.response.type;
                    let reader = new FileReader();
                    reader.onload = () => {
                        let result = reader.result;
                        result = result.replace(type, mimeType[format]);
                        resolve(result);
                    }
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                } else {
                    reject();
                }
            }
        };
        xhr.onerror = reject;
        xhr.send(null);
    });
    
};
function getScale(w, h){
    let maxSize = 1024 - imgPadding * 2;
    let scale = Math.min(maxSize / w, maxSize / h);
    if(scale <= 1){
        return scale;
    } else {
        return Math.min(2, scale);
    }
}

export default catchScreen;